module.exports = __webpack_public_path__ + "img/new-rule-box.bf5e5fa3.png";